import { IComponentOptions } from "angular";
import { ContactBookController } from "./controller";
export const vsComponentName = "contactBook";
export const ContactBookComponentOptions: IComponentOptions =
{
  controller: ContactBookController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    contactBook: "<",
  },
};
